import { getBaseRole } from '@/helpers/customRoles';
import { usersAPI } from "@/api";
import { useEffect, useState } from "react";

const initState = {
    type: null,
}
export const useGetDataForEditEntityModal = ({ priorities, userId }) => {
    const [dataForEditEntityModal, setDataForEditEntityModal] = useState(initState);
    
    const getData = async () => {
        if(!userId) {
            setDataForEditEntityModal(initState);
            return;
        }
        const res = await usersAPI.getUser({ id: userId, expand: ["roles"] });
        let newData = null;
        if (res?.data) {
           for (const priority of priorities) {
            if(priority === 'student' && res?.data?.roles?.find(role => getBaseRole(role.item_name) === "children")){
                    newData = {
                        studentId: userId,
                        type: priority,
                        userId
                    } 
                    break; 
                }
                if(priority === 'parent' && res?.data?.roles?.find(role => getBaseRole(role.item_name) === 'parent')){
                    newData = {
                        parentId: userId,
                        type: priority,
                        userId
                    }
                    break; 
                }
                if(
                    priority === 'employee' &&
                    res?.data?.roles?.map(el => el.item_name)?.some(item => item !== 'children' && item !== 'parent')
                    ) {
                    newData = {
                        employeeId: userId,
                        type: priority,
                        userId 
                    }
                    break;
                }
            }
            if(newData){
                setDataForEditEntityModal(newData)
            }
            else{
                setDataForEditEntityModal(initState)
            }
        }
    }
    useEffect(()=> {
        getData()
    }, [userId])

    return { dataForEditEntityModal }
}
